export const Name = "st6";


//////////////////
// WEBPACK FOOTER
// ./public/my.env.js
// module id = 81
// module chunks = 1